/** Presentation labels for scraper-captured Meta ad attribute enums (CTA type, display format). */

/** Formats stay acronyms; anything else reads as a sentence-case phrase. */
const ACRONYM_FORMATS = new Set(['DCO', 'DPA'])

/** `SHOP_NOW` → `Shop now`. Returns null for empty values so callers can skip the chip. */
export function formatAdAttributeLabel(value: string | null | undefined) {
    if (!value) return null
    const words = value.replace(/_/g, ' ').trim().toLowerCase()
    if (!words) return null
    return words.charAt(0).toUpperCase() + words.slice(1)
}

/** `DCO` stays `DCO`; `CAROUSEL` → `Carousel`. */
export function formatDisplayFormatLabel(value: string | null | undefined) {
    if (!value) return null
    if (ACRONYM_FORMATS.has(value.toUpperCase())) return value.toUpperCase()
    return formatAdAttributeLabel(value)
}
